import { render, staticRenderFns } from "./table.vue?vue&type=template&id=70d3701a&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"
import style0 from "./table.vue?vue&type=style&index=0&id=70d3701a&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d3701a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70d3701a')) {
      api.createRecord('70d3701a', component.options)
    } else {
      api.reload('70d3701a', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=70d3701a&scoped=true", function () {
      api.rerender('70d3701a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/report_form/into_activity_application/table.vue"
export default component.exports